export class HistEstaInfoI{
  id : BigInteger;
  accion : String;
  usuario : String;
  fecha : String;
  idEstadoInfo : BigInteger;
}
